// Feature flags for FE surfaces whose AgentCore Engine endpoints have not
// been deployed yet. Flags are build-time env vars (CRA), default OFF; flip a
// flag to 'true' in .env/.env.beta/.env.prod only once the engine PR that
// serves it is deployed. Gated surfaces are fully hidden (routes, nav
// entries, panels), never just disabled, so nothing visible can call a
// missing endpoint.
//
// Flag → engine PR mapping (engine branch add-attribution-rubrics; PRs merge
// in order PR1 → PR2 → PR3 → PR5 → PR6 → PR10):
//
// - (ungated)                        Rubric editor + rubric display and the
//                                    changeNote/motivatingCaseRn guide-edit
//                                    fields need only engine PR1
//                                    (PUT /domain_guide/{rn}/rubric).
// - oversightMarkingControlsEnabled  Needs engine PR2 deployed
//                                    (PUT /domain_guide/{rn}/marking): the
//                                    guide-detail marking controls card
//                                    (enabled/live/stakes/sampleRate).
// - oversightMarkingReadsEnabled     Needs engine PR2 + PR3 deployed: case
//                                    marks panel (GET /case/{rn}/marks),
//                                    agent report card page + nav entry
//                                    (GET /metrics/agent_report_card), and
//                                    the case-list mark filter/chip (the
//                                    markingStatus case-query projection).
// - oversightCaseReviewEnabled       Needs engine PR3 deployed
//                                    (POST /case/{rn}/review): the case
//                                    review card.
const parseFlag = (value) => `${value}`.trim().toLowerCase() === 'true';

const featureFlags = {
  oversightMarkingControlsEnabled: parseFlag(process.env.REACT_APP_OVERSIGHT_MARKING_CONTROLS_ENABLED),
  oversightMarkingReadsEnabled: parseFlag(process.env.REACT_APP_OVERSIGHT_MARKING_READS_ENABLED),
  oversightCaseReviewEnabled: parseFlag(process.env.REACT_APP_OVERSIGHT_CASE_REVIEW_ENABLED),
};

export default featureFlags;
